var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoDrag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "25px",
    viewBox: "0 0 26 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "45E31F35-465F-4BA0-8F6F-F6F2651D825E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-1233.000000, -80.000000)",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "drag",
    transform: "translate(1235.000000, 81.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(14.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.308203125,3.5 L7.49980469,3.5",
    id: "Path-18"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "4.8 0 8 3.51470713 4.8 7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(11.000000, 18.500000) rotate(90.000000) translate(-11.000000, -18.500000) translate(7.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.308203125,3.5 L7.49980469,3.5",
    id: "Path-18"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "4.8 0 8 3.51470713 4.8 7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(11.000000, 4.500000) scale(1, -1) rotate(90.000000) translate(-11.000000, -4.500000) translate(7.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.308203125,3.5 L7.49980469,3.5",
    id: "Path-18"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "4.8 0 8 3.51470713 4.8 7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(4.000000, 11.500000) scale(1, -1) rotate(180.000000) translate(-4.000000, -11.500000) translate(0.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.308203125,3.5 L7.49980469,3.5",
    id: "Path-18"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "4.8 0 8 3.51470713 4.8 7"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDrag);
export default __webpack_public_path__ + "static/media/ico_drag.67fd8d0dd2052593a5969054bbf32dab.svg";
export { ForwardRef as ReactComponent };